import React from 'react'
import { MDBContainer, MDBIcon, MDBInput } from 'mdb-react-ui-kit'
import MDB4Datatable from '../../../../content/MDB4Datatable/MDB4Datatable.component'
import { toast } from 'react-toastify'
import moment from 'moment'
import { MessageFactory } from './../../../../../shared/factories'
import PaginationComponent from './../../../../../components/adminShared/Pagination.component'

import './MessagesList.scss'

const timezoneOffset = new Date().getTimezoneOffset()

class MessagesList extends React.Component {
  state = {
    loading: true,
    messages: [],
    pagination: { page: 0, per_page: 10, total: 0 },
    search: '',
    tableData: {
      columns: [
        {
          label: 'Message Title',
          field: 'title',
          sort: 'asc',
          width: 150,
        },
        {
          label: 'Category',
          field: 'category',
          sort: 'asc',
          width: 150,
        },
        {
          label: 'Updated Date',
          field: 'updated_at',
          sort: 'asc',
          width: 150,
        },
        {
          label: 'Start Date',
          field: 'start_date',
          sort: 'asc',
          width: 150,
        },
        {
          label: 'End Date',
          field: 'end_date',
          sort: 'asc',
          width: 150,
        },
        {
          label: 'Edit',
          field: 'edit',
          sort: 'disabled',
          width: 150,
        },
      ],
      rows: [],
    },
  }

  componentDidMount() {
    this.#fetchMessages()
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.division_id !== this.props?.division_id || prevProps?.category !== this.props?.category) {
      this.#fetchMessages()
    }
  }

  componentWillUnmount() {
    // No subscriptions to clean up anymore
  }

  #fetchMessages = async (page = 0, perPage = 10) => {
    this.setState({ loading: true })

    try {
      const search = { category: this.props?.category }

      if (this.props?.division_id) {
        search.division_id = parseInt(this.props.division_id)
      }

      const { models, pagination } = await MessageFactory.search({
        search,
        pagination: { page, per_page: perPage },
      })

      // Convert Message models to plain objects using .all() method
      this.setState(
        {
          messages: models.map(msg => msg.all()),
          pagination: pagination || { page, per_page: perPage, total: 0 },
          loading: false,
        },
        this.#setRows
      )
    } catch (error) {
      console.error('Error fetching messages:', error)
      toast.error('Failed to load messages', {
        position: toast.POSITION.TOP_RIGHT,
      })
      this.setState({ loading: false })
    }
  }

  #editMessage = id => {
    if (typeof this.props.onEdit === 'function') this.props.onEdit(id)
  }

  #buildRows = () => {
    const { messages } = this.state

    return messages && Array.isArray(messages)
      ? messages.map(row => {
          const { title, category, updated_at, id, start_date, end_date, deleted_at } = row,
            editBtn = (
              <div className={'d-flex align-items-center justify-content-center'}>
                <div className={'cursor-pointer d-inline-block'} role={'button'} onClick={() => this.#editMessage(id)}>
                  <MDBIcon icon={deleted_at ? 'eye' : 'edit'} size='2x' className='blue-text p-1' />
                </div>
              </div>
            ),
            formatedDate = (
              <span searchvalue={updated_at ? moment(updated_at).format('YYYY/MM/DD') : ''}>
                {updated_at ? moment(updated_at).format('MM/DD/YYYY') : 'N/A'}
              </span>
            ),
            formatedStartDate = (
              <span
                searchvalue={
                  start_date
                    ? moment(new Date(new Date(start_date).getTime() + timezoneOffset * 60000)).format('YYYY/MM/DD')
                    : ''
                }
              >
                {start_date
                  ? moment(new Date(new Date(start_date).getTime() + timezoneOffset * 60000)).format('MM/DD/YYYY')
                  : 'N/A'}
              </span>
            ),
            formatedEndDate = (
              <span
                searchvalue={
                  end_date
                    ? moment(new Date(new Date(end_date).getTime() + timezoneOffset * 60000)).format('YYYY/MM/DD')
                    : ''
                }
              >
                {end_date
                  ? moment(new Date(new Date(end_date).getTime() + timezoneOffset * 60000)).format('MM/DD/YYYY')
                  : 'N/A'}
              </span>
            )

          return {
            title: title,
            category: category,
            updated_at: formatedDate,
            start_date: formatedStartDate,
            end_date: formatedEndDate,
            edit: editBtn,
          }
        })
      : []
  }

  #setRows = () =>
    this.setState({
      tableData: { ...this.state.tableData, rows: this.#buildRows() },
    })

  #handleSearch = async term => {
    // Implement search functionality if needed
    // For now, just refetch with search term
    if (term && term.length > 0) {
      this.setState({ loading: true })
      try {
        const search = {
          category: this.props?.category,
          title: term, // Assuming you want to search by title
        }

        if (this.props?.division_id) {
          search.division_id = parseInt(this.props.division_id)
        }

        const { models, pagination } = await MessageFactory.search({
          search,
          pagination: { page: 0, per_page: 10 },
        })

        this.setState(
          {
            messages: models.map(msg => msg.all()),
            pagination: pagination || { page: 0, per_page: 10, total: 0 },
            loading: false,
          },
          this.#setRows
        )
      } catch (error) {
        console.error('Error searching messages:', error)
        this.setState({ loading: false })
      }
    } else {
      // If search is cleared, refetch all messages
      this.#fetchMessages()
    }
  }

  #searchMessages = async term => {
    this.setState({ search: term.target.value })
    // Debounce could be implemented here, but for simplicity, calling directly
    setTimeout(() => {
      if (this.state.search === term.target.value) {
        this.#handleSearch(term.target.value)
      }
    }, 500)
  }

  #onPageChange = (page, perPage) => {
    this.#fetchMessages(page, perPage)
  }

  render() {
    toast.configure()

    const { tableData, loading, pagination, search } = this.state

    return (
      <MDBContainer id='MessagesListComponent' fluid>
        {loading ? (
          <h4 className={'p4'}>Loading...</h4>
        ) : (
          <div className='table-wrapper'>
            <MDBInput
              label='Search Messages'
              name='search'
              id='manage-msg-search'
              value={search}
              onChange={this.#searchMessages}
            />
            <MDB4Datatable
              data={tableData}
              searching={false}
              paging={false}
              sortRows={['updated_at', 'start_date', 'end_date']}
              striped
              bordered
              small
              className='text-capitalize'
            />
            {pagination && parseInt(pagination.total) > 0 && (
              <>
                <div className='pagination-wrapper'>
                  <PaginationComponent
                    pagination={pagination}
                    onPageSelect={(page, perPage) => this.#onPageChange(page, perPage)}
                  />
                </div>
              </>
            )}
          </div>
        )}
      </MDBContainer>
    )
  }
}

export default MessagesList
